import {Component, Host, h, Prop, State, Watch, Listen, forceUpdate, EventEmitter, Event} from '@stencil/core';
import {RequestFieldGroup} from "../../classes/request_field_group";
import {ITransactionValues} from "../../interfaces/transaction";
import {Logger} from "../../utils/logger";

@Component({
  tag: 'securecall-transaction',
  styleUrl: 'securecall-transaction.css',
  shadow: true,
})
export class SecurecallTransaction {
  @Prop() fieldData: RequestFieldGroup
  @Prop() transactionToggle: boolean;

  @State() isFormValid = false;

  @Event() submitTransactionEvent: EventEmitter<ITransactionValues>;

  private readonly log = new Logger('SecurecallTransaction')

  @Watch('transactionToggle')
  transactionTogglePropHandler(newValue: any, oldValue: any) {
    if (newValue !== oldValue) {
      this.updateFormValidity();
    }
  }

  @Watch('fieldData')
  fieldDataPropHandler(newValue: any, oldValue: any) {
    this.log.debug('fieldDataPropHandler: newValue:', newValue, 'oldValue:', oldValue);
    if (newValue !== oldValue) {
      this.updateFormValidity();
    }
  }

  handleSubmit(){
    this.log.debug('handleSubmit:', this, this.submitTransactionEvent)
    this.submitTransactionEvent.emit(this.fieldData.asAPITransaction());
  }

  @Listen('isValidEvent')
  handleIsValidEvent(event: CustomEvent<{ field: string; valid: boolean; value: string }>) {
    const { field, valid, value } = event.detail;
    this.log.debug('isValidEvent: field:', field, 'valid:', valid, 'value:', value,);
    if (field && this.fieldData.transaction[field]) {
      this.fieldData.transaction[field].valid = valid;
      this.fieldData.transaction[field].value = value;
      this.updateFormValidity();
    }
  }

  @Listen('requestRadioChangeEvent')
  async handleRadioChange(event: CustomEvent<{ field: string, value: string }>) {
    this.log.debug("requestRadioChangeEvent: " + event.detail);
    // this.isFormValid = false;
    const { field, value } = event.detail;
    let fields = this.fieldData.calculatedFields();
    Object.entries(fields[field]['hideRelatedFields']?.[value] || {}).forEach(([relatedField, val]) => {
      let f = this.fieldData.transaction[relatedField];
      if (f) {
        f['hidden'] = val;
      }
    });
    forceUpdate(this);
  }

  private updateFormValidity() {
    const invalidFields = Object.entries(this.fieldData.calculatedFields())
      .filter(([_fieldName, field]) => !field.hidden && !field.valid)
      .map(([fieldName]) => fieldName);

    this.isFormValid = invalidFields.length === 0;
    this.log.debug('updateFormValidity: isFormValid:', this.isFormValid, 'invalidFields:', JSON.stringify(invalidFields));
  }

  ////////////////////////////
  // Render Methods
  ////////////////////////////

  private renderFields() {
    this.log.debug("renderFields: fieldData=", this.fieldData);
    const fields = this.fieldData?.asComponentChildren() || [];
    this.log.debug("renderFields: fields=", fields);
    return fields.map((field) => {
            const Tag = 'securecall-request-'+ field.component;
            return <Tag id={field.name} field-name={field.name} config={field.config}></Tag>;
          })
  }

  renderButtons() {
    return (
      <div class="component-field-container">
        <div></div>
        <button type="button" class="component-button" onClick={() => this.handleSubmit()} disabled={!this.isFormValid}>Submit Transaction</button>
      </div>
    )
  }

  render() {
    return (
      <Host>
        <form class="component-form">
          {this.renderFields()}
          {this.renderButtons()}
        </form>
      </Host>
    );
  }
}
